import React, { FC, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router';
import { Button } from '../../../../components/common';
import { MainSource } from '../../../../constants/Source';
import { RouteBuilder } from '../../../../utils/RouteHelpers';
import { IOuter } from '../EmptyState.types';

export const ExploreShutterstockButton: FC<IOuter> = () => {
  const history = useHistory();
  const handleClick = useCallback(() => history.push(RouteBuilder.Source(MainSource.Shutterstock)), [history]);

  return (
    <Button
      size="small"
      skin="standard"
      priority="secondary"
      onClick={handleClick}
      dataHook="explore-shutterstock-button"
    >
      <FormattedMessage id="empty-state.explore-shutterstock" />
    </Button>
  );
};
